export default {"src":"/_next/static/image/public/images/ic_attach_blue.2e4372906f38b451921d89aa2fdcb4eb.svg","height":15,"width":15};